import { html } from 'lit';
import { Sun } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-sun')
export class PdsIconSun extends PdsIcon {
  @state()
  icon = Sun;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
